import FingerprintJS from '@fingerprintjs/fingerprintjs';

import { setBrowserId } from '../actions/global';

export const setBrowserID = (enqueueSnackbar) => async (dispatch) => {
  try {
    const fingerPrint = await FingerprintJS.load();
    const { visitorId } = await fingerPrint.get();

    dispatch(setBrowserId(visitorId));
  } catch (error) {
    enqueueSnackbar(error.message);
  }
};
